
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Destinationweddingsportnearnagpur() {



  const cardData =
  {
    keyword: ' Destination Wedding Spots Near Nagpur',
    heading:  'Woodland Escape: Destination Wedding Spots Near Nagpur',
    headingDescription: 'Destination Wedding Spots Near Nagpur offers a dreamy stage for your big day just outside the city, where lush greenery, open lawns and elegant event spaces come together to create memorable celebrations. Featuring resorts nestled amidst forest fringes, hill-backdrops and serene landscapes, these venues seamlessly combine natural beauty with refined amenities for weddings that feel both luxurious and grounded in nature. Whether you’re planning a grand reception under the stars, an intimate ceremony amid trees, or a multi-day festivity with family and friends, destination wedding spots near Nagpur ensure flawless logistics, vibrant settings and a refreshing change of pace from everyday life. From expansive lawns to boutique resorts, each location promises style, comfort and unforgettable moments crafted around you.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
    {
      "name": "Destination Wedding Spots Near Nagpur",
      "description": "Woodland Escape Resort is among the best destination wedding spots near Nagpur, offering a perfect blend of elegance and natural beauty. With lush lawns, scenic backdrops, and luxurious accommodations, the resort provides an ideal setting for a dream wedding. Couples can enjoy customizable décor, catering options, and a peaceful environment surrounded by greenery, making every moment truly special."
    },
    {
      "name": "Nagpur Wedding Resorts",
      "description": "For those seeking the finest wedding resorts in Nagpur, Woodland Escape Resort stands out as a top choice. The resort combines modern amenities with serene surroundings, making it perfect for wedding ceremonies, receptions, and pre-wedding events. Spacious banquet areas, outdoor lawns, and personalized services ensure your big day is both elegant and memorable."
    },
    {
      "name": "Nagpur Marriage Venues",
      "description": "Woodland Escape Resort offers stunning marriage venues near Nagpur designed to host both grand celebrations and intimate gatherings. From open-air lawns to decorated banquet halls, every space is tailored for elegance and comfort. The professional team at the resort helps coordinate décor, food, and guest arrangements to ensure a seamless and joyous wedding experience."
    },
    {
      "name": "Nagpur Luxury Wedding Locations",
      "description": "When it comes to luxury wedding locations near Nagpur, Woodland Escape Resort is unmatched. With beautifully landscaped gardens, exclusive suites for guests, and exquisite dining options, it delivers a royal wedding experience. Every detail—from floral arrangements to lighting—is curated to create an atmosphere of sophistication and romance."
    },
    {
      "name": "Affordable Wedding Spot Nagpur",
      "description": "Woodland Escape Resort provides affordable yet elegant wedding packages near Nagpur. Couples can host beautiful celebrations without compromising on quality. The resort’s team assists with all arrangements—venue setup, catering, and entertainment—ensuring a perfect balance of luxury and value. It’s ideal for those seeking a budget-friendly yet memorable wedding."
    },
    {
      "name": "Nagpur Pre Wedding Shoot Locations",
      "description": "Capture your love story at one of Nagpur’s most enchanting pre-wedding shoot locations—Woodland Escape Resort. The resort’s scenic gardens, water features, and rustic countryside charm make it a photographer’s paradise. Couples can choose from a variety of picturesque backdrops to create timeless memories before their big day."
    },
    {
      "name": "Nagpur Resort Wedding Venue",
      "description": "Woodland Escape Resort is an exceptional resort wedding venue near Nagpur, offering a mix of natural elegance and modern luxury. Perfect for destination weddings, the resort includes lush outdoor spaces and indoor banquet areas suitable for all wedding functions. It ensures a stress-free experience with complete event management and hospitality support."
    },
    {
      "name": "Nagpur Outdoor Wedding Places",
      "description": "For outdoor wedding places near Nagpur, Woodland Escape Resort provides breathtaking open spaces surrounded by nature. Couples can exchange vows under the sky amidst flower-decked mandaps and scenic backdrops. The resort’s team manages décor, catering, and lighting to create a fairytale-like outdoor ceremony experience."
    },
    {
      "name": "Nagpur Hill Wedding Location",
      "description": "Experience the magic of a hill wedding near Nagpur at Woodland Escape Resort. The resort’s elevated location provides panoramic views and cool breezes, making it a dreamy spot for destination weddings. Its natural landscape enhances the charm of every celebration, offering a unique and serene setting for couples to say ‘I do.’"
    },
    {
      "name": "Nagpur Riverside Wedding Resort",
      "description": "Celebrate your special day at Woodland Escape Resort, a serene riverside wedding resort near Nagpur. The tranquil river views, open-air lawns, and soft ambient lighting create a romantic setting for ceremonies and receptions. Guests can enjoy nature’s beauty while the resort’s team ensures flawless arrangements from start to finish."
    },
    {
      "name": "Nagpur Family Wedding Resort",
      "description": "Woodland Escape Resort is the perfect family wedding resort near Nagpur, offering spacious accommodations and multiple venues for large gatherings. Families can enjoy a blend of comfort and celebration with beautifully designed spaces for rituals, dining, and entertainment. The resort ensures a warm, family-friendly atmosphere that enhances every wedding event."
    },
    {
      "name": "Nagpur Wedding Booking",
      "description": "Easily manage your Nagpur wedding booking at Woodland Escape Resort with the help of an experienced event team. From venue selection to menu planning and décor setup, every detail is handled with care. Flexible booking options make it convenient for couples to plan weddings of all scales—grand or intimate."
    },
    {
      "name": "Nagpur Wedding Packages",
      "description": "Woodland Escape Resort offers customizable wedding packages near Nagpur that include venue access, catering, décor, entertainment, and accommodation. Whether it’s a one-day celebration or a multi-event wedding, each package is designed to suit your preferences and budget. Enjoy a stress-free wedding planning experience with everything handled under one roof."
    },
    {
      "name": "Nagpur Wedding Hall Near Me",
      "description": "If you’re searching for a wedding hall near Nagpur, Woodland Escape Resort offers elegant indoor spaces ideal for ceremonies and receptions. The hall is beautifully designed with modern décor and can accommodate both small and large gatherings. Combined with outdoor lawns, it provides a versatile venue for any type of wedding celebration."
    },
    {
      "name": "Nagpur Wedding Destination Packages",
      "description": "For destination wedding packages near Nagpur, Woodland Escape Resort delivers a complete experience—from stay and meals to décor and event planning. The resort’s scenic surroundings and professional services make it an ideal venue for couples who dream of a destination-style wedding without leaving the region. Every package ensures comfort, elegance, and unforgettable memories."
    }
  ],
  "tableData": [
    ["- Destination Wedding Spots Near Nagpur", "- Nagpur Wedding Resorts"],
    ["- Nagpur Marriage Venues", "- Nagpur Luxury Wedding Locations"],
    ["- Affordable Wedding Spot Nagpur", "- Nagpur Pre Wedding Shoot Locations"],
    ["- Nagpur Resort Wedding Venue", "- Nagpur Outdoor Wedding Places"],
    ["- Nagpur Hill Wedding Location", "- Nagpur Riverside Wedding Resort"],
    ["- Nagpur Family Wedding Resort", "- Nagpur Wedding Booking"],
    ["- Nagpur Wedding Packages", "- Nagpur Wedding Hall Near Me"],
    ["- Nagpur Wedding Destination Packages", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Dream Destination Wedding Spot Near Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort is one of the most enchanting destination wedding spots near Nagpur, offering a perfect blend of natural beauty and elegant comfort. Nestled within a serene forest, the resort provides a magical setting for couples who wish to celebrate their special day surrounded by lush greenery, tranquility, and timeless charm."
  },
  {
    "WhyChooseheading": "Scenic Forest Backdrop for Wedding Ceremonies",
    "WhyChoosedescription": "Imagine exchanging vows beneath tall trees, with the soothing sounds of nature all around. Woodland Escape Resort offers breathtaking forest backdrops for wedding ceremonies, pre-wedding photoshoots, and outdoor receptions. The natural décor and fresh air create a romantic atmosphere that adds a fairytale touch to your big day."
  },
  {
    "WhyChooseheading": "Spacious Venues and Elegant Setups",
    "WhyChoosedescription": "From open lawns and forest clearings to cozy banquet areas, Woodland Escape Resort provides versatile spaces that can be customized for every wedding event — haldi, mehndi, sangeet, or reception. Our team helps design elegant setups that match your theme and vision, ensuring a seamless celebration from start to finish."
  },
  {
    "WhyChooseheading": "Accommodation and Comfort for Guests",
    "WhyChoosedescription": "The resort offers comfortable and beautifully designed rooms and cottages for guests to relax and enjoy the wedding festivities. Each space reflects the rustic charm of the forest while providing modern amenities. Your loved ones can celebrate together while enjoying a peaceful stay surrounded by nature."
  },
  {
    "WhyChooseheading": "Delicious and Customizable Catering",
    "WhyChoosedescription": "Treat your guests to a culinary experience they’ll remember. Woodland Escape Resort offers diverse menu options, from traditional Maharashtrian dishes to multi-cuisine feasts. Our chefs use fresh, locally sourced ingredients to create delicious meals that suit your event’s theme and preferences."
  },
  {
    "WhyChooseheading": "Perfect for Pre-Wedding and Post-Wedding Events",
    "WhyChoosedescription": "Whether it’s a pre-wedding shoot, an intimate mehndi celebration, or a relaxed post-wedding brunch, Woodland Escape Resort offers the perfect ambiance for every moment. The surrounding forest, tranquil atmosphere, and open spaces make it an unforgettable setting for all your wedding festivities."
  },
  {
    "WhyChooseheading": "Easily Accessible from Nagpur",
    "WhyChoosedescription": "Located just a short drive from Nagpur, Woodland Escape Resort is easily reachable while still offering the seclusion of a true nature retreat. The scenic drive through the countryside sets a romantic tone, making it a convenient and stunning destination for couples seeking a forest-themed wedding experience."
  }
]





  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort one of the best destination wedding spots near Nagpur?",
    answer: "Woodland Escape Resort offers a stunning natural backdrop, spacious lawns, and elegant event spaces, making it one of the most beautiful destination wedding spots near Nagpur. Our team ensures every celebration is unique, romantic, and memorable."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur?",
    answer: "The resort is located around 45 km from Nagpur, easily reachable within 1 to 1.5 hours by road. It’s a convenient and scenic venue for couples who want a countryside wedding close to the city."
  },
  {
    question: "What wedding facilities and services do you offer?",
    answer: "We provide complete wedding arrangements, including venue decoration, catering, accommodation, sound and lighting setups, photography support, and event coordination. Whether it’s a grand celebration or an intimate ceremony, we customize everything to your needs."
  },
  {
    question: "Can we host pre-wedding and post-wedding events at the resort?",
    answer: "Yes! Our resort is ideal for hosting engagement parties, haldi, mehendi, sangeet, and reception ceremonies. The scenic surroundings and spacious lawns provide the perfect setting for vibrant pre-wedding photoshoots and celebrations."
  },
  {
    question: "Is accommodation available for guests?",
    answer: "Absolutely! Woodland Escape Resort offers comfortable rooms, cottages, and suites for wedding guests. Each accommodation combines modern comfort with a natural ambiance, ensuring a relaxing stay for everyone attending the event."
  },
  {
    question: "How can we book Woodland Escape Resort for a destination wedding?",
    answer: "You can contact our wedding planning team directly by phone, WhatsApp, or through our official website. We recommend booking well in advance to secure your preferred dates and customize your wedding package."
  }
];

const testimonials = [
  {
    name: "Mr. Karan & Family, Nagpur",
    text: "Our daughter’s wedding at Woodland Escape Resort was a dream come true! The natural setting, decorations, and arrangements were simply perfect. The staff handled everything beautifully, making our celebration stress-free and memorable."
  },
  {
    name: "Miss. Priya & Team, Wardha",
    text: "We attended a destination wedding at Woodland Escape Resort, and it was magical! The venue looked stunning, the food was excellent, and the atmosphere was filled with joy. Truly one of the best wedding spots near Nagpur!"
  }
];




      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Destination Wedding Spots Near Nagpur",
  "image": "https://woodlandescape.com/assets/images/destination-wedding-spots-near-nagpur.jpg",
  "description": "Plan your dream wedding at Woodlandescape Resort — one of the best destination wedding spots near Nagpur. Experience luxury, nature, and elegance with beautiful outdoor venues, banquet options, and complete wedding packages.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1342"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "49999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/destination-wedding-spots-near-nagpur"
  }
};



  return (
    <div>
<Helmet>
  <title>Destination Wedding Spots Near Nagpur | Luxury Wedding Resort | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Celebrate your special day at Woodlandescape Resort — the most beautiful destination wedding spot near Nagpur. Perfect for outdoor ceremonies, pre-wedding shoots, and luxurious wedding celebrations with customized packages." 
  />
  <meta 
    name="keywords" 
    content="Destination Wedding Spots Near Nagpur, Nagpur Wedding Resorts, Nagpur Marriage Venues, Nagpur Luxury Wedding Locations, Affordable Wedding Spot Nagpur, Nagpur Pre Wedding Shoot Locations, Nagpur Resort Wedding Venue, Nagpur Outdoor Wedding Places, Nagpur Hill Wedding Location, Nagpur Riverside Wedding Resort, Nagpur Family Wedding Resort, Nagpur Wedding Booking, Nagpur Wedding Packages, Nagpur Wedding Hall Near Me, Nagpur Wedding Destination Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/5.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Destinationweddingsportnearnagpur;